<template>
    <div class="dashboard main-con">
        <template v-if="showDesktop">
            <div class="banner-wrapper">
                <main-header></main-header>
                <div class="sub-nav-wrapper con-wrapper">
                    <div class="sub-menu-con">
                        <base-menu class="sub-menu" :menu="sub_menu"></base-menu>
                        <button class="btn btn-success" @click="$router.push({ name: 'user-credits' })">
                            <span>{{ credits < 10 ? $t('Get Credits') : `${credits} ${$t('Credits')}` }}</span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="content-con">
                <div class="con-wrapper">
                    <div class="wrappers">
                        <div class="sidebar-wrapper">
                            <profile-sidebar></profile-sidebar>
                        </div>
                        <div class="content-wrapper">
                            <slot name="content"></slot>
                        </div>
                    </div>
                </div>
            </div>
            <main-footer></main-footer>
        </template>
        <div v-else :class="['content-con mobile', {'with-title': title}, {'no-top-nav': !hasTopNavBar}, {'fix-footer-bottom': fixedFooter}]">
            <m-top-nav-bar v-if="hasTopNavBar" :title="title" :icon-right="iconRight" :icon-in-title="iconInTitle"
            @right-icon-click-event="$emit('right-icon-click-event')" @icon-in-title-click-event="$emit('icon-in-title-click-event')"></m-top-nav-bar>
            <div :class="`con-wrapper ${mobileNoPad ? 'no-pad' : ''} ${darkBg ? 'dark-bg' : ''}`">
                <div class="wrappers">
                    <slot name="mobile-content"></slot>
                </div>
            </div>
            <div v-if="unread_messages" class="circle-blur" @click="$router.push({name:'user-messages'})">{{ unread_messages }}</div>
        </div>
    </div>
</template>

<script>
    import MainHeader from '@views/common/MainHeader'
    import MainFooter from '@views/common/MainFooter'
    import MTopNavBar from '@views/user/partials/mobile/MTopNavBar'
    import BaseMenu from '@views/common/BaseMenu'
    import ProfileSidebar from '@views/user/partials/ProfileSidebar'
    import Dashboard from '@views/user/layouts/Dashboard/dashboard'

    export default {
        mixins: [Dashboard],
        components: {
            MainHeader,
            MainFooter,
            MTopNavBar,
            BaseMenu,
            ProfileSidebar
        }
    }
</script>

<style lang="scss" src="./dashboard.scss"></style>
